<template>
  <div v-if="suggestions.length && fieldFocus" id="search-suggestions">
    <ul>
      <li
        v-for="(suggestion, index) in suggestions"
        :key="
          suggestion.brandName +
            suggestion.temper +
            suggestion.isoDesignation +
            index
        "
        @click="searchByKeyword(suggestion)"
      >
        {{ suggestion.brandName }}
      </li>
    </ul>
  </div>
</template>

<script>
import Store from "@/store";

export default {
  props: {
    searchTerm: {
      type: String,
      default: null
    },
    fieldFocus: {
      type: Boolean,
      default: false
    },
    removeFieldFocus: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      store: Store.state,
      suggestions: []
    };
  },
  watch: {
    searchTerm: function() {
      if (this.searchTerm.length > 2) {
        this.getSuggestions();
      } else {
        this.suggestions = [];
      }
    }
  },
  methods: {
    getSuggestions() {
      this.suggestions = this.store.alloysBackup.filter(alloy => {
        const searchTerm = this.searchTerm.toLowerCase().trim();

        // Search on alloysBrand
        const brandName = alloy["brandName"].toLowerCase();
        if (brandName.includes(searchTerm)) {
          return true;
        }

        // Search through alloys keywords
        for (let keyword of alloy["keywords"]) {
          const keywordFormatted = keyword.toLowerCase();
          if (keywordFormatted.includes(searchTerm)) {
            return true;
          }
        }
      });
    },
    searchByKeyword(alloySelected) {
      Store.searchByKeyword(alloySelected);
      this.$emit("removeFieldFocus");
    }
  }
};
</script>

<style lang="scss" scoped>
#search-suggestions {
  background-color: white;
  color: black;
  margin-top: 5px;
  position: absolute;
  // top = searchBar height
  top: 40px;
  left: 0;
  z-index: 1;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 3px 4px;
  border-radius: 5px;

  ul {
    padding: 10px 0;
    margin-bottom: 0;
  }

  li {
    list-style: none;
    padding: 5px 20px;

    &:hover {
      cursor: pointer;
      background: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
